import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Button, Modal, Spin, message } from "antd";
// import AmCharts from "@amcharts/amcharts3-react";
import { LoadingOutlined, MoreOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import liracrypt from "../../../Liracrypt/liracrypt";
import ApiErrorComp from "../../../ApiErrorComp/ApiErrorComp";
import { createRoute } from "../../../../utils/CustomFunc";
import { useSelector } from "react-redux";
import noImg from '../../../../assets/static/noImg.jpeg';
import ZenModal from "../../../ZenModal";
import queryString from "query-string";
import { useLocation } from 'react-router-dom';


am4core.useTheme(am4themes_animated);

const ZenGauge = (props) => {
  const urlCode = useSelector(state => state.urlCode);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState();
  const [chartConfig, setChartConfig] = useState();
  const createChart = (args, chart) => {
    chart.innerRadius = am4core.percent(args.config.chartDiv.innerRadiusPercent);
    chart.margin(args.config.chartDiv.style.margin[0], args.config.chartDiv.style.margin[1], args.config.chartDiv.style.margin[2], args.config.chartDiv.style.margin[3]);
    chart.padding(args.config.chartDiv.style.padding[0], args.config.chartDiv.style.padding[1], args.config.chartDiv.style.padding[2], args.config.chartDiv.style.padding[3]);

    if (args.config.title.enable === true) {
      var title = chart.titles.create();
      title.text = args.config.title.val;
      title.fontSize = args.config.title.fontSize;
      title.margin(args.config.title.margin[0], args.config.title.margin[1], args.config.title.margin[2], args.config.title.margin[3]);
      title.padding(args.config.title.padding[0], args.config.title.padding[1], args.config.title.padding[2], args.config.title.padding[3]);
      title.fontWeight = args.config.title.fontWeight;
      title.fill = args.config.title.color;
      title.dx = args.config.title.dx;
      title.dy = args.config.title.dy;
    }
    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = args.config.valueAxis.min;
    valueAxis.max = args.config.valueAxis.max;
    valueAxis.strictMinMax = args.config.valueAxis.strictMinMax;
    valueAxis.renderer.labels.template.fontSize =
      args.config.valueAxis.label.fontSize;
    valueAxis.renderer.labels.template.fill = args.config.valueAxis.label.color;
    if (args.config.axisRange.enable !== true) {
      valueAxis.renderer.labels.template.disabled = true;
    }

    // Range
    var axisRange = valueAxis.axisRanges.create();
    axisRange.value = args.config.axisRange.value;
    axisRange.endValue = args.config.axisRange.endValue;
    axisRange.axisFill.fillOpacity = args.config.axisRange.fillOpacity;
    axisRange.axisFill.fill = args.config.axisRange.color;
    if (args.config.axisRange.shadow.enable === true) {
      var shadow = valueAxis.filters.push(new am4core.DropShadowFilter());
      shadow.dx = args.config.axisRange.shadow.dx;
      shadow.dy = args.config.axisRange.shadow.dy;
      shadow.blur = args.config.axisRange.shadow.blur;
    }

    // Main label
    if (args.config.label.enable === true) {
      var label = chart.radarContainer.createChild(am4core.Label);
      label.isMeasured = false;
      // label.x = am4core.percent(args.config.label.x);
      // label.y = am4core.percent(args.config.label.y);
      // label.dx = am4core.percent(args.config.label.dx);
      // label.dy = am4core.percent(args.config.label.dy);
      label.horizontalCenter = args.config.label.horizontalCenter;
      label.verticalCenter = args.config.label.verticalCenter;
      label.fontSize = args.config.label.fontSize;
      label.fontWeight = args.config.label.fontWeight;
      label.text = args.data.labelText;
      label.fill = args.config.label.color;
      label.stroke = args.config.label.color;
      //NOTE: MARGIN AND PADDING IS REPLACED WITH dx AND dy
      // label.margin(args.config.label.margin[0],args.config.label.margin[1],args.config.label.margin[2],args.config.label.margin[3]);
      // label.padding(args.config.label.padding[0],args.config.label.padding[1],args.config.label.padding[2],args.config.label.padding[3]);
      label.dx = args.config.label.dx;
      label.dy = args.config.label.dy;
      // label.dx = am4core.percent(args.config.label.dx);
      // label.dy = am4core.percent(args.config.label.dy);
    }

    var clockHand = chart.hands.push(new am4charts.ClockHand());
    clockHand.pin.disabled = true;
    clockHand.innerRadius = am4core.percent(args.config.hand.innerRadiusPercent);
    clockHand.radius = am4core.percent(args.config.hand.outerRadiusPercent);
    clockHand.width = args.config.hand.width;
    clockHand.value = args.data.valPerc;
    clockHand.fill = am4core.color(args.config.hand.fill);
    clockHand.stroke = am4core.color(args.config.hand.stroke);

    if (args.config.hand.shadow.enable === true) {
      var shadow = clockHand.filters.push(new am4core.DropShadowFilter());
      shadow.dx = args.config.hand.shadow.dx;
      shadow.dy = args.config.hand.shadow.dy;
      shadow.blur = args.config.hand.shadow.blur;

    }

    chartRef.current = chart;
  }

  const getApiChartData = (args) => {
    let params = { ...args?.params };
    liracrypt
      .get(props.api, { ...searchParams, ...props.urlData, ...params })
      .then((response) => {
        console.log(response.data.data[props.divId]);
        if (!response.data.data[props.divId]) {
          return console.log("No Data Found");
        };
        if (props.setChartId) {
          props.setChartId(response.data.data[props.divId].meta._id);
        }
        if (props.setChartDataSource) {
          props.setChartDataSource(response.data.data[props.divId].meta.autoMan);
        }
        setChartData(response.data.data[props.divId]);
        // setTimeout(() => {
        //   chart = am4core.create(props.divId, am4charts.XYChart)
        //   createChart({
        //     data: response.data.data[props.divId].data,
        //     config: response.data.data[props.divId].config
        //   },
        //     chart);
        // }, 500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.refreshChart) {
      getApiChartData();
    }
  }, [props.refreshChart])

  /* CHART CREATION */
  useEffect(() => {
    let chart = null;
    if (props.api) {
      setChartData(null);
      getApiChartData();
    } else if (props.data) {
      setChartData({ data: props.data, config: props.config });
      // setTimeout(() => {
      //   chart = am4core.create(props.divId, am4charts.XYChart)
      //   createChart({ data: props.data, config: props.config }, chart);
      // }, 500);
    }
  }, [props?.data]);

  useEffect(() => {
    var chart = null;
    if (chartData) {
      chart = am4core.create(props.divId, am4charts.GaugeChart);
      createChart({ data: chartData.data, config: chartData.config }, chart);
      return () => {
        chart.dispose();
      };
    }
  }, [chartData]);

  useEffect(() => {
    let interval;
    if (chartData?.config?.dataRefreshInterval) {
      interval = setInterval(() => {
        getApiChartData();
      }, chartData?.config?.dataRefreshInterval);
    };
    return () => clearInterval(interval);
  }, [chartData?.config?.dataRefreshInterval]);

  const [zenModal, setZenModal] = useState();

  const [modal, setModal] = useState({
    type: "route",
    data: undefined,
    show: false,
    loading: false,
  });

  const toggleModal = ({
    show = false,
    data = undefined,
    type = '',
    loading = false,
  }) => {
    setModal({ show, data, type, loading });
  };

  const zenPopupAction = (zenPopup, value, record) => {
    let urlData = { ...searchParams, ...props.urlData, ...zenPopup.params };
    if (zenPopup?.props) {
      urlData[zenPopup?.props] = value;
    }
    if (zenPopup?.multiProps) {
      zenPopup?.multiProps.forEach((prop) => {
        urlData[prop] = record[prop];
      });
    }
    if (zenPopup?.typ === 'smodal') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          id: value,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    };
    if (zenPopup?.typ === 'route') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          route: zenPopup?.route,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    }
    if (zenPopup?.api) {
      toggleModal({ show: true, loading: true, type: zenPopup?.typ });
      liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
        toggleModal({
          show: true,
          data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
          loading: false,
          type: zenPopup?.typ
        })
      });
      return;
    }
    return toggleModal({
      show: true,
      data: zenPopup?.data,
      loading: false,
      type: zenPopup?.typ
    })
  }

  const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
    if (popData.method === 'GET') {
      liracrypt.get(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'POST') {
      liracrypt.post(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          console.log(err);
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'PATCH') {
      liracrypt.patch(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
  }

  const onColumnClick = (record) => {
    if (chartData?.config?.zenPop) {
      let zenPopDataIndex = { ...chartData?.config?.zenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  const onMenuClick = (record = {}) => {
    if (chartData?.config?.menuZenPop) {
      let zenPopDataIndex = { ...chartData?.config?.menuZenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }


  return (
    <div>
      {chartData?.data ? (
        <>
          {
            chartData?.config?.menuZenPop?.enable ?
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={() => onMenuClick()} type="link" icon={
                  <MoreOutlined />}>{''}</Button>
              </div> : <></>
          }
          <div
            id={props.divId}

            style={
              chartData.config.chartDiv.style}

          ></div>
          <ZenModal
            modal={modal}
            toggleModal={toggleModal}
            smodalCallback={props.api ? getApiChartData : props.smodalCallback}
            refreshData={props.api ? (params) => getApiChartData({ params }) : (params) => props.refreshData({ ...params })}
            zenModal={zenModal}
          />
        </>

      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default ZenGauge;
